import { BiometricDatapointRecord } from 'services/biometricsService';
import { buildLastSevenDays } from 'utils/dateUtils';
import { MealReading, normalizeMealRelationship } from './bloodGlucoseMeals';

// Unlike the widget's `buildLastSevenDays()` (always pinned to today), the detail page's window
// isn't pinned to "today" — the member pages back/forward through history 7 days at a time. The
// underlying day-key algorithm is identical, so this just re-exports it under a clearer name here.
export const buildWeekWindow = buildLastSevenDays;

// Always "Apr 27 - May 03, 2026" (short month, two-digit day, both months repeated) so the label
// keeps one shape as the member pages between windows.
const formatRangeDay = (date: Date) =>
  date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });

export const formatDateRangeLabel = (days: string[]): string => {
  const start = new Date(`${days[0]}T00:00:00`);
  const end = new Date(`${days[days.length - 1]}T00:00:00`);
  return `${formatRangeDay(start)} - ${formatRangeDay(end)}, ${end.getFullYear()}`;
};

export interface PastReading {
  id: number;
  date: string;
  value: number;
  meal: MealReading | null;
}

// Every reading within the window, latest first (by day, then time of reading), for the
// scrollable "Past Readings" table.
export const toPastReadings = (
  datapoints: BiometricDatapointRecord[],
  days: string[],
): PastReading[] => {
  const daySet = new Set(days);
  return datapoints
    .filter((point) => daySet.has(point.userLocalDateCaptured.slice(0, 10)))
    .sort(
      (a, b) =>
        b.userLocalDateCaptured.localeCompare(a.userLocalDateCaptured) ||
        Date.parse(b.timeOfReading) - Date.parse(a.timeOfReading) ||
        Date.parse(b.createdAt) - Date.parse(a.createdAt) ||
        b.id - a.id,
    )
    .map((point) => ({
      id: point.id,
      date: point.userLocalDateCaptured.slice(0, 10),
      value: point.value,
      meal: normalizeMealRelationship(point.relationshipToMeal),
    }));
};
